import { cx } from '../../utils/cx';
import { formatAbsolute, formatShort, relativeDate, todayIso } from '../../utils/dates';
import s from './RelativeDate.module.css';

export type RelativeDateProps = {
  /** YYYY-MM-DD */
  date: string;
  /** YYYY-MM-DD "today" (pass the family's today from the API; defaults to the device's). */
  today?: string;
  /** How to show the absolute date: inline after a "·" (default), on its own line, or not at all. */
  absolute?: 'inline' | 'below' | 'none';
  className?: string;
};

/** "in 23 days · Fri, Dec 25". The absolute date is always visible, never hover-only. */
export function RelativeDate({
  date,
  today = todayIso(),
  absolute = 'inline',
  className,
}: RelativeDateProps) {
  const rel = relativeDate(date, today);
  const abs = formatAbsolute(date, today);
  // Past ~60 days there is no relative phrase — `relativeDate` returns the short date —
  // so showing both would read "Dec 25 · Fri, Dec 25". Keep the fuller one.
  const relativeIsJustTheDate = rel === formatShort(date);

  return (
    <time dateTime={date} className={cx(s.date, className)} data-layout={absolute}>
      {relativeIsJustTheDate ? null : <span>{rel}</span>}
      {absolute !== 'none' || relativeIsJustTheDate ? (
        <span className={relativeIsJustTheDate ? undefined : s.absolute}>{abs}</span>
      ) : null}
    </time>
  );
}
